import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssessmentFormEditComponent } from '@feature/assessment-form/assessment-form-edit/assessment-form-edit.component';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateEditSubmissionGuard {

  constructor(@Inject('windowRef') private window: Window, private readonly router: Router) {}

  canDeactivate(
    component: AssessmentFormEditComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!component.dataChanged) {
      return true;
    }
    const url = this.router.url;
    return component.confirmLeavePage().pipe(
      tap(state => {
        if (!state) {
          this.window.history.pushState(null, '', url);
        }
      })
    );
  }
}
